import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import Employee from './Employee'
import Spinner from '@components/spinner'
import Scroll from '@components/Scroll'

class EmployeePage extends Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string
      }).isRequired,
      url: PropTypes.string
    }).isRequired,
    employeeStore: PropTypes.object,
    location: PropTypes.object
  }

  constructor (props) {
    super(props)
    this.loadEmployee()
  }

  loadEmployee () {
    const { employeeStore, match } = this.props
    const employeeId = Number(match.params.id)

    employeeStore.get(employeeId)
  }

  renderSpinner () {
    return <Spinner />
  }

  render () {
    const { employeeStore, match, location } = this.props

    if (employeeStore.loading) {
      return <Spinner />
    }

    return (
      <Scroll>
        <Employee
          employeeStore={employeeStore}
          matchId={match.params.id}
          matchUrl={location.pathname}
          match={match}
        />
      </Scroll>
    )
  }
}

export default withRouter(inject('employeeStore')(observer(EmployeePage)))
